<ul>
    @for (label of labels; track label; let labelIndex = $index) {
        <li>
            <app-doughnut-chart-data-visualization-label [label]="label"
                                                         [color]="colors[labelIndex]" />
        </li>
    }
</ul>
